export default __webpack_public_path__ + "static/media/logo2.2d3368d0.png";